import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IPopcornRepository } from '../../repositories/interfaces/iPopcornRepository';
import { IGenreRatingConfig } from '../../../entity/interface/iPopcornResponse';

export interface iGetPromotionsUseCase {
    execute(
        apikey: string,
        device: string,
        country: string,
        subscriptionGuids: string,
        tierGuid: string,
        operator: string,
        subStatus: string,
        productKey: string,
        range: string,
        providers: { [key: string]: { [key: string]: string } },
        lang: string,
        genreRatingConfig: IGenreRatingConfig,
        dataSources: string
    ): Promise<any>;
}

export class GetPromotionsUseCase implements iGetPromotionsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getPromotions(): IPopcornRepository {
        return container.resolve<IPopcornRepository>(DI.REPOSITORIES.IPopcornRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apikey: string,
        device: string,
        country: string,
        subscriptionGuids: string,
        tierGuid: string,
        operator: string,
        subStatus: string,
        productKey: string,
        range: string,
        providers: { [key: string]: { [key: string]: string } },
        lang: string,
        genreRatingConfig: IGenreRatingConfig,
        dataSources: string
    ): Promise<any> {
        return await this.getPromotions.getPromotions(
            apikey,
            device,
            country,
            subscriptionGuids,
            tierGuid,
            operator,
            subStatus,
            productKey,
            range,
            providers,
            lang,
            genreRatingConfig,
            dataSources
        );
    }
}
